import script from "./MoneyHubLinkPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MoneyHubLinkPage.vue?vue&type=script&setup=true&lang=ts"

import "./MoneyHubLinkPage.vue?vue&type=style&index=0&id=42308e80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42308e80"]])

export default __exports__